/**
 * Created by evgenijsenkevic on 12/8/25
 */

const GDComPayments = function () {
    Payments.call(this, connector.GDCOM, {
        sdk: SdkManager.SDK_GDCOM
    });

    connector.social.whenConnected(() => {
        if (this.socialConnectCallback) {
            this.socialConnectCallback();
            delete this.socialConnectCallback;
        }
    });
};

GDComPayments.prototype = Object.create(Payments.prototype);
GDComPayments.prototype.constructor = GDComPayments;

GDComPayments.prototype.getProductId = function (product) {
    return product.id.gdcom;
};

GDComPayments.prototype._connect = function (callback) {
    new ConnectorActionPlayer([
        (f) => {
            if (connector.social.isConnected()) {
                f();
            } else {
                this.socialConnectCallback = f;
            }
        }
    ]).play(() => {
        callback(connector.STATUS_CONNECTED);
    });
};

GDComPayments.prototype._loadProducts = function (callback) {
    if (!connector.social.isLoggedIn()) {
        console.log("load products failed - not logged in");
        callback(connector.CODE_FAILED);
        return;
    }

    gdsdk.executeStoreAction({ action: "api.items" })
        .then((items) => {
            console.log("api.items result", items);

            if (!Array.isArray(items) || items.length === 0) {
                callback(connector.CODE_FAILED);
                return;
            }

            let currency;
            const loadedIds = items.map((item) => item.sku);

            items.forEach((item) => {
                const product = this.getProduct(item.sku);
                if (!product) {
                    return;
                }

                const priceInfo = item.price;
                const amount = parseFloat(priceInfo.amount);
                currency = priceInfo.currency;

                product.textPrice = this.getTextPrice(amount, currency);
                product.price = amount;
                product.currency = currency;

                if (item.virtual_item_type === "non_consumable") {
                    product.type = "nonConsumable";
                } else if (item.virtual_item_type === "consumable") {
                    product.type = "consumable";
                }
            });

            if (currency) {
                this.currency = currency;
            }

            callback(connector.CODE_SUCCEED, loadedIds);
        })
        .catch((e) => {
            this.bus.trigger("error:details:gdcom:loadProducts", e);
            callback(connector.CODE_FAILED);
        });
};

GDComPayments.prototype.purchase = function (product, callback) {
    gdsdk.executeStoreAction({
        action: "api.buyProduct",
        payload: { sku: product.productId, quantity: 1 }
    }).then((result) => {
        if (result && result.paid) {
            console.log("success purchase", result);

            const payload = { data: result.data };
            const purchase = this.createPurchase(result.data.purchase_invoice_id, product, payload);
            callback(connector.CODE_SUCCEED, purchase);
        } else {
            callback(ERRORS.PURCHASE.CANCEL);
        }
    }).catch((error) => {
        this.bus.trigger("stream:error", `GDComPayments.purchase productId:${product.productId} ${JSON.stringify(error)}`);
        callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: error && error.code, message: error && error.message });
    });
};

GDComPayments.prototype.restore = function (callback) {
    if (!connector.social.isLoggedIn()) {
        console.log("restore failed - not logged in");
        callback(connector.CODE_FAILED);
        return;
    }

    gdsdk.executeStoreAction({ action: "api.inventoryItems" })
        .then((items) => {
            if (!Array.isArray(items) || items.length === 0) {
                callback(connector.CODE_FAILED);
                return;
            }

            console.log("gdcom inventoryItems result", items);

            const item = items[0];
            const product = this.getProduct(item.sku);

            if (!product) {
                this.bus.trigger("stream:error", `GDComPayments.restore product not found sku:${item.sku}`);
                callback(connector.CODE_FAILED);
                return;
            }

            const purchase = this.createPurchase(undefined, product);

            callback(connector.CODE_SUCCEED, purchase);
        })
        .catch((error) => {
            this.bus.trigger("stream:error", `GDComPayments.restore ${JSON.stringify(error)}`);
            callback(connector.CODE_FAILED);
        });
};

GDComPayments.prototype.consume = function (purchase, callback) {
    gdsdk.executeStoreAction({
        action: "api.consume",
        payload: { sku: purchase.productId, quantity: 1 }
    }).then((consumeResult) => {
        console.log("gdcom consume result", consumeResult);
        callback(connector.CODE_SUCCEED);
    }).catch((error) => {
        this.bus.trigger("stream:error", `GDComPayments.consume ${JSON.stringify(error)}`);
        callback(connector.CODE_FAILED);
    });
};

GDComPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.GDCOM) && connector.info.hybrid;
};